import { apiPost } from 'api';
import { RequestExtensionRequest, RequestExtensionResponse } from '../../types';

export const requestExtension = (
  request: RequestExtensionRequest
): Promise<RequestExtensionResponse> =>
  apiPost<RequestExtensionResponse, RequestExtensionRequest>(
    `consultations/${request.consultationId}/requestextension`,
    request
  );
